<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model.personalDealDetail" :rules="validatorRules" slot="detail" :colon="false">
        <Detail ref="detailRef" v-show="showDetail" />
        <!-- 施工申请 -->
         <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item :label="$t('施工申请描述')" prop="constructionApplicationDescription">
              <a-textarea v-model="model.personalDealDetail.constructionApplicationDescription" :placeholder="$t('请输入施工申请描述')" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="16">
            <a-form-model-item :label="$t('图片')" prop="constructionApplicationPicture">
              <j-image-upload class="avatar-uploader" :text="$t('施工申请照片材料')" :isMultiple="true" v-model="model.personalDealDetail.constructionApplicationPicture"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('施工申请模版')" prop="annex">
              <div class="template-download">
                <a
                  :href="excavationTemplateUrl"
                  target="_blank"
                  :download="$t('施工申请模板.docx')"
                >
                  <a-icon type="download" /> {{ $t('下载模板') }}
                </a>
                <span class="template-name">{{ $t('施工申请模板.docx') }}</span>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>

        
        

      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Detail from '../detail'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JUpload,
      JImageUpload,
      DetailList,
      DetailListItem,
      Detail
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        showDetail: false,
        validatorRules: {
     
        },
        url: {
          add: "/jeecg-engineering/engineering/engineeringDrawing/add",
          edit: "/jeecg-engineering/engineering/engineeringDrawing/edit",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          list: "/jeecg-engineering/engineering/engineeringDrawing/list",
          upload: "sys/common/upload",
          // userList: "/jeecg-engineering/flowable/definition/userList",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
          editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName",
        },
        // 模板文件URL，可以是静态资源路径或后端接口返回的URL
        excavationTemplateUrl: '/templates/excavation_application_template.docx',
        fileList: [],
        candidateUsersList: [],
        userCaliberList: [],
        ticketsData: {},
        bool: false,
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    watch:{
      'model.audit':{
        handler(val){
          if(val == 1){
            this.validatorRules.remark1.required = false;
          }else{
            this.validatorRules.remark1.required = true;
          }
        }
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      uploadChange(file){
        // this.model.annex = file;
        this.$set(this.model.engineeringDrawing,'annex',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('annex');
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,bool) {
        let that = this;
        this.bool = bool;
        this.model = Object.assign({});
        if(record.id){
          // 获取详情信息
          getAction(this.url.queryById,{id:record.id}).then(res=>{
            if(res.success){
              that.ticketsData = { ...res.result }
              that.model = { 
                ...res.result.installationDetail,
               }
               if (that.model.annex == null) {
                  that.fileList = []
                } else {
                  that.fileList = [that.model.annex];
                }
                // 确保子组件已挂载
                that.$nextTick(() => {
                  if(that.$refs.detailRef) {
                    that.$refs.detailRef.init(that.ticketsData, bool);
                    that.showDetail = true;
                  } else {
                    console.error('子组件引用不存在');
                  }
                });
            }
          })
        }
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = this.url.pass;
            let method = 'post';
            let message = this.$t('处理成功');

            let params = {
                dataId: that.ticketsData.id,
                createTicketDTO:{
                  ticketsInstallationReq: {
                    ...that.model
                  },
                },
                comment: ''
              }

            httpAction(httpurl,params,method).then((res) => {
              if (res.success) {
                that.$message.success(message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
              that.confirmLoading = false;
            }).finally(() => {
              that.confirmLoading = false;
            })
            
          }
        })
      },
    }
  }
</script>
<style>
  .lab-title{
    font-weight: bold;
    color: #000;
  }
  .template-download {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fafafa;
}

.template-download a {
  margin-right: 8px;
  color: #1890ff;
}

.template-name {
  color: rgba(0, 0, 0, 0.65);
}
</style>